import React from 'react';
import PropTypes from 'prop-types';

import {
    useGetCapitalAccountsQuery,
    useGetCapitalCallsQuery,
    useGetClosingsQuery,
    useGetNAVQuery,
    useGetShareSubcategoriesQuery,
} from 'api/main';
import { useInvestorPortfolioData } from 'utils/hooks';
import { parseSum } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import PortfolioRow from './PortfolioRow';
import { StyledTableRow, Loader } from 'components';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const ProtfolioTable = props => {
    const { finishedSubscriptions, hideColumns, fullWidth } = props;

    const { data: shareSubcategories = [], isLoading: subcategoriesLoader } =
        useGetShareSubcategoriesQuery();
    const { data: capitalCalls = [], isLoading: capitalCallsLoader } = useGetCapitalCallsQuery({
        status: ['completed', 'activated'],
        pagination: false,
    });
    const { data: capitalAccounts = [], isLoading: capitalAccountsLoader } =
        useGetCapitalAccountsQuery({ pagination: false });
    const { data: closings = [], isLoading: closingsLoader } = useGetClosingsQuery({
        status: ['completed', 'activated'],
        pagination: false,
    });
    const { data: navs = [] } = useGetNAVQuery({
        pagination: false,
        status: ['completed', 'activated'],
    });

    const totalData = useInvestorPortfolioData({
        finishedSubscriptions,
        shareSubcategories,
        capitalAccounts,
        capitalCalls,
        closings,
        navs,
    });

    if (!finishedSubscriptions.length) return null;

    return (
        <Loader
            loading={
                subcategoriesLoader || capitalAccountsLoader || capitalCallsLoader || closingsLoader
            }
        >
            <Box width={fullWidth ? '100%' : '85%'} marginX="auto" overflow="auto" marginBottom={5}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{texts.FUND}</TableCell>
                            <TableCell>{texts.ENGAGEMENT_DATE}</TableCell>
                            <TableCell>{texts.SHARES_NUMBER}</TableCell>
                            <TableCell>{texts.CATEGORIE_DE_PARTS}</TableCell>
                            <TableCell>{texts.ENGAGEMENT}</TableCell>
                            <TableCell>{texts.CAPITAL_CALLED}</TableCell>
                            <TableCell>{texts.CAPITAL_DUE}</TableCell>
                            <TableCell>{texts.LAST_CALL_DATE}</TableCell>
                            <TableCell>{texts.VALORISATION}</TableCell>
                            <TableCell>{texts.DISTRIBUTIONS}</TableCell>
                            <TableCell>{texts.IRR}</TableCell>
                            <TableCell>{texts.DPI}</TableCell>
                            <TableCell>{texts.RVPI}</TableCell>
                            <TableCell>{texts.TVPI}</TableCell>
                            {!hideColumns && <TableCell>{texts.PARTNER}</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {finishedSubscriptions.map(s => (
                            <PortfolioRow
                                hideColumns={hideColumns}
                                key={s.id}
                                subscription={s}
                                capitalAccounts={capitalAccounts}
                                shareSubcategories={shareSubcategories}
                                capitalCalls={capitalCalls}
                                closings={closings}
                                navs={navs}
                            />
                        ))}
                        {finishedSubscriptions.length > 1 && (
                            <StyledTableRow>
                                <TableCell align="left">
                                    <b>{texts.TOTAL}</b>
                                </TableCell>
                                <TableCell colSpan={3}>{/* empty space */}</TableCell>
                                <TableCell>
                                    <b>{parseSum(totalData.totalInvestments)}</b>
                                </TableCell>
                                <TableCell>
                                    <b>{parseSum(totalData.totalCapitalCalled)}</b>
                                </TableCell>
                                <TableCell>
                                    <b>{parseSum(totalData.totalCapitalRemaining)}</b>
                                </TableCell>
                                <TableCell>{/* empty space */}</TableCell>
                                <TableCell>
                                    <b>{parseSum(totalData.totalValueToDate)}</b>
                                </TableCell>
                                <TableCell colSpan={hideColumns ? 5 : 6}>
                                    {/* empty space */}
                                </TableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </Box>
        </Loader>
    );
};

ProtfolioTable.propTypes = {
    finishedSubscriptions: PropTypes.array,
    hideColumns: PropTypes.bool,
    fullWidth: PropTypes.bool,
};

export default ProtfolioTable;
